/* eslint-disable no-nested-ternary */
import { NavItem } from '@im/ui-lib/mf-utils';

export function framedRoute(path: string) {
  return `/frame?url=${encodeURIComponent(path)}`;
}

export function validateProperty(
  menuData: any,
  property: string,
  index: number
): string {
  return menuData &&
    menuData.menuitems &&
    menuData.menuitems.length > 0 &&
    menuData.menuitems[index] &&
    menuData.menuitems[index][property]
    ? menuData.menuitems[index][property]
    : '';
}

export function buildNavMenuItem(menuData: any, locale: string): NavItem[] {
  const navItems: NavItem[] = [];
  locale = locale?.toLowerCase();

  const count =
    menuData && menuData.total && menuData.total > 0 ? menuData.total : 0;

  if (menuData && count > 0) {
    for (let i = 0; i < count; i++) {
      const pageName = validateProperty(menuData, 'pageName', i);
      const pagePath = validateProperty(menuData, 'partialPageUrl', i);
      const subMenu = menuData.menuitems[i].subMenu;
      const route = `cms/${locale}/${pagePath}`;
      if (subMenu.length > 0) {
        const subItems = subMenu.map((menu: any) => {
          return {
            key: menu.pageName,
            label: menu.pageName,
            route: `cms/${locale}/${menu.partialPageUrl}`,
          };
        });
        navItems.push({
          key: pageName,
          label: pageName,
          navItems: subItems,
          route: pagePath && route,
        });
      } else if (pageName !== '') {
        navItems.push({
          key: pageName,
          label: pageName,
          route,
        });
      }
    }
  }
  return navItems;
}

export function handleKenticoOnClick(fn: string) {
  return () => {
    try {
      // eslint-disable-next-line no-new-func
      new Function(fn)();
    } catch (e) {
      console.error(e);
    }
  };
}

export function buildHelpMenuItem(menuData: any): NavItem[] {
  const navItems: NavItem[] = [];

  const hasData = menuData && menuData.length > 0;

  if (hasData) {
    for (const item of menuData) {
      const menuItem = {
        key: item.title,
        label: item.title,
        onClick: item.isModel ? handleKenticoOnClick(item.onClick) : undefined,
        route: item.openUrlInNewTab ? undefined : item.url,
        url: item.openUrlInNewTab ? item.url : undefined,
      } as NavItem;
      navItems.push(menuItem);
    }
  }
  return navItems;
}

export const getCloudServicesLink = (env: string, country: string) => {
  if (country === 'gb') country = 'uk';
  return `https://cp.${country}${
    env === 'production'
      ? '.na'
      : env === 'productionbeta'
      ? '.prodbeta.na'
      : '.stg'
  }.cloud.im/?external_idp=IMOnline`;
};

export enum CountryCode {
  AT = 'at',
  AU = 'au',
  BE = 'be',
  CA = 'ca',
  DE = 'de',
  ES = 'es',
  FR = 'fr',
  GB = 'gb',
  IN = 'in',
  IT = 'it',
  MX = 'mx',
  NZ = 'nz',
  UK = 'uk',
  US = 'us',
  USME = 'usme',
}

export const applicationCenterAvailability = ({
  siteCode,
}: {
  siteCode: string;
}) => {
  const countryCodes = Object.values(CountryCode) as string[];
  return countryCodes.includes(siteCode);
};
export const navItemsDataAttributes: Record<string, string> = {
  'Cloud reports': 'Mybusiness_CloudReports',
  'Reports (Beta)': 'Mybusiness_Reports(Beta)',
};
